import jQuery from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade, Autoplay } from "swiper/modules";

jQuery(function ($) {
  // initialize accordoins
  initAccordions();

  // init info sliders
  initInfoSliders();

  // init featured recipes slider
  initFeaturedRecipesSlider();

  // init product details slider
  initProductDetailsSlider();

  // init product timeline slider
  initProductTimelineSlider();

  // init banner slider
  initBannerSlider();

  // init loadMore button on featured products
  loadMoreFeaturedProducts();

  setupJudgemeReviews();
});

document.addEventListener("DOMContentLoaded", () => {
  initVideos();
});

// Initialize Info sliders
function initInfoSliders() {
  $(".info-slider-container").each(function () {
    var textEl = $(this).find(".info-slider--text").get(0);
    var mediaEl = $(this).find(".info-slider--media").get(0);
    var swiperText, swiperMedia;
    swiperText = new Swiper(textEl, {
      modules: [Pagination, EffectFade],
      effect: "fade",
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      on: {
        init: function (swiper) {
          swiper.el.classList.add(`current-index-${swiper.realIndex}`);
        },
        slideChange: function (swiper) {
          swiper.el.className = swiper.el.className.replace(
            /\bcurrent-index.*?\b/g,
            ""
          );
          swiper.el.classList.add(`current-index-${swiper.realIndex}`);
          // $(swiper.el).addClass(`current-index-${swiper.realIndex}`);
          if (swiperMedia !== undefined) {
            swiperMedia.slideTo(swiper.realIndex);
          }
        },
      },
    });
    swiperMedia = new Swiper(mediaEl, {
      modules: [Pagination],
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      on: {
        slideChange: function (swiper) {
          if (swiperText !== undefined) {
            swiperText.slideTo(swiper.realIndex);
          }
        },
      },
    });

    // To fix sliders which are not properly initialized when hidden
    window.addEventListener("JBupdateInfoSliders", () => {
      if (swiperText) swiperText.update();
      if (swiperMedia) swiperMedia.update();
    });
  });

  $(".slide--read-more").on("click", function (e) {
    e.preventDefault();
    $(this)
      .closest(".swiper-wrapper")
      .css({ height: "auto" })
      .toggleClass("expanded-text");
  });
}

// Initialize videos with poster images
function initVideos() {
  const videos = document.querySelectorAll(".js-video-with-poster");

  videos.forEach((video) => {
    // Handle video play/pause on click
    video.addEventListener("click", (e) => {
      e.preventDefault();
      if (!video.hasAttribute("controls")) {
        video.setAttribute("controls", "controls");
      }
      if (video.paused || video.ended) {
        video.play().catch((error) => {
          console.error("Video playback failed:", error);
        });
      } else {
        video.pause();
      }
    });

    // Handle when the video ends
    video.addEventListener("ended", (e) => {
      video.pause(); // Ensure the video is paused
      video.currentTime = 0; // Reset video to the start
      video.removeAttribute("controls"); // Remove controls if necessary
      // Force reload the poster by reloading the video
      video.load();
    });
  });
}

// Initialize accordions
function initAccordions() {
  $(".js-accordion-item").each(function (index, item) {
    $(item)
      .find(".accordion-item--title")
      .on("click", function () {
        $(this).toggleClass("is-active");
        $(this).siblings(".accordion-item--description").slideToggle();
      });
  });
}

// Initialize featured recipes slider
function initFeaturedRecipesSlider() {
  $(".featured-recipes--swiper").each(function (index, item) {
    var recipesSwiper = new Swiper(item, {
      modules: [Navigation],
      spaceBetween: 12,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
}

// Initialize product details slider on collection page
function initProductDetailsSlider() {
  $(".product-details--grid").each(function (index, item) {
    var sliderEl = $(item).find(".product-details--media-swiper").get(0);

    var productSlider = new Swiper(sliderEl, {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 8,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    $(item)
      .find(".color-radio")
      .on("change", function (index, item) {
        var color = $('input[name="color"]:checked').val();

        var slideIndex = $(sliderEl)
          .find(`.swiper-slide[data-image-color=${color}]`)
          .index();
        productSlider.slideTo(slideIndex);
      });
  });
}

// Initialize product timeline slider
function initProductTimelineSlider() {
  $(".pt--slider").each(function (index, item) {
    var productTimelineSlider = new Swiper(item, {
      modules: [Navigation],
      slidesPerView: "auto",
      // centeredSlides: true,
      // loop: true,
      loopAdditionalSlides: 3,
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
}

// Initialize banner slider
function initBannerSlider() {
  $(".banner-slider-container").each(function (index, item) {
    var sliderEl = $(item).find(".banner-slider-swiper").get(0);

    var options = {
      modules: [Autoplay, EffectFade],
      fadeEffect: {
        crossFade: true,
      },
      effect: "fade",
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      loop: true,
    };

    if ($(sliderEl).hasClass("has-pagination")) {
      options.pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
      options.modules.push(Pagination);
    }
    if ($(sliderEl).hasClass("has-navigation")) {
      options.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
      options.modules.push(Navigation);
    }
    var bannerSlider = new Swiper(sliderEl, options);
  });
}

function setupJudgemeReviews() {
  if ($("#judgeme_product_reviews").length > 0) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          if ($(mutation.target).hasClass("jdgm--done-setup-widget")) {
            let text = $(".jdgm-rev-widg__summary-average").text().trim();
            let firstWord = text.split(" ")[0];
            $(".jdgm-rev-widg__summary-average").text(firstWord);
            observer.disconnect();
          }
        }
      });
    });

    observer.observe(document.getElementById("judgeme_product_reviews"), {
      attributes: true,
    });
  }
}

function loadMoreFeaturedProducts() {
  if ($(".featured-products-container").length) {
    $(".featured-products-container .load-more-wrap .load-more-button").on(
      "click",
      function () {
        let container = $(this).closest(".featured-products-container");
        let pageSize = parseInt($(this).data("page-size"));
        let products = $(container).find(
          ".products-grid .card-product.initially-hidden"
        );

        if ($(products).length && pageSize) {
          $(products).each((index, item) => {
            if (index + 1 <= pageSize) {
              $(item).removeClass("initially-hidden");
            }
          });

          if ($(products).length < pageSize) {
            $(container).find(".load-more-wrap").remove();
          }
        }
      }
    );
  }
}
